<template>
	<div>
		<v-card class="mx-auto elevation-0" style="max-width: 500px">
			<v-form ref="signupform" v-model="valid" class="pa-4 pt-6">
				<v-row>
					<v-col class="pb-0">
						<v-select
							v-model="select"
							name="industry"
							:items="industryList"
							:rules="[v => !!v || 'Industry is required']"
							required
							label="Industry"
							outlined
						></v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="sx-6 pb-0 pt-0">
						<v-text-field v-model="firstname" label="First Name" :rules="[v => !!v || 'First name is required']" outlined required></v-text-field>
					</v-col>
					<v-col class="sx-6 pb-0 pt-0">
						<v-text-field v-model="lastname" label="Last Name" :rules="[v => !!v || 'Last name is required']" outlined required></v-text-field>
					</v-col>
				</v-row>

				<VuePhoneNumberInput
					v-model="phoneNumber"
					:rules="[v => !!v || 'Mobile number is required']"
					default-country-code="ZA"
					:preferred-countries="['ZA']"
					label="Mobile Number"
					outlined
					required
					size="lg"
					class="mt-0 mb-5"
					:countries-height="40"
					error-color="red"
					color="orange"
					@update="onChangeTelNumber"
				/>

				<v-row>
					<v-col class="pb-0">
						<v-select
							v-model="heardFromWhere"
							name="heardFromWhere"
							:items="heardFromWhereOptions"
							:rules="[v => !!v || 'Please choose an option']"
							required
							label="How did you hear about us?"
							outlined
						></v-select>
					</v-col>
				</v-row>

				<v-text-field
					v-if="heardFromWhereText.purpose"
					v-model="heardFromWhereText.text"
					:label="HFWTextLabels[heardFromWhereText.purpose]"
					outlined
					required
				></v-text-field>

				<v-text-field v-model="email" :rules="emailRules" label="E-mail" outlined required></v-text-field>

				<v-text-field v-model="confirmedEmail" :rules="[emailConfirmationRule]" label="Confirm E-mail" outlined required></v-text-field>

				<v-text-field
					id="password"
					v-model="password"
					label="Password"
					outlined
					:type="showPassword ? 'text' : 'password'"
					:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
					required
					name="password"
					:rules="passwordRules"
					@click:append="showPassword = !showPassword"
				></v-text-field>

				<v-text-field
					id="confirmpassword"
					v-model="confirmpassword"
					label="Confirm Password"
					:rules="[...passwordRules, passwordConfirmationRule]"
					outlined
					:type="showconfirmPassword ? 'text' : 'password'"
					:append-icon="showconfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
					name="confirmpassword"
					required
					@click:append="showconfirmPassword = !showconfirmPassword"
				></v-text-field>

				<v-checkbox
					v-model="agreement"
					color="green"
					:rules="[v => !!v || 'You must accept the terms and conditions to continue.']"
					label="I accept the LocumBase terms and conditions"
				>
					<template #label>
						<v-row>
							<v-col class>
								I accept the LocumBase
								<a target="_blank" href="https://locumbase.com/terms-and-conditions" @click.stop> terms and conditions </a>
							</v-col>
						</v-row>
					</template>
				</v-checkbox>
			</v-form>

			<!-- General error messages -->
			<p v-for="message in generalError" v-show="generalError.length > 0" :key="message" error class="text-center error--text mt-2">{{ message }}</p>

			<v-card-actions class="pa-5 pt-0">
				<v-spacer />

				<v-btn class="ma-2 pa-5 text-none" :disabled="!valid || loading" :loading="loading" depressed large rounded color="primary" @click="signUp"
					>Continue
					<v-icon right>mdi-arrow-right</v-icon>
				</v-btn>

				<v-spacer />
			</v-card-actions>
		</v-card>

		<!-- General Error Snackbar -->
		<v-snackbar v-model="errorSnackbar" top color="white" :timeout="6000" class="black--text">
			{{ errorMessage }}
			<v-btn outlined class="black--text" @click="errorSnackbar = false"> Close </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { fetchTenant } from '@/utils/auth.js';

export default {
	components: { VuePhoneNumberInput },

	data: () => ({
		valid: false,
		showPassword: false,
		showconfirmPassword: false,
		loading: false,
		errorSnackbar: false,
		errorMessage: '',
		userisconfirmed: true,
		firstname: '',
		lastname: '',
		phoneNumber: null,
		phoneNumberFormatted: null,
		heardFromWhere: null,
		heardFromWhereText: {
			purpose: null,
			text: ' ',
		},
		phone: null,
		country: null,
		bindProps: {
			mode: 'international',
			placeholder: 'Enter a phone number',
			required: false,
			enabledCountryCode: true,
			enabledFlags: true,
			autocomplete: 'off',
			name: 'telephone',
			maxLen: 25,
			inputOptions: {
				showDialCode: true,
			},
		},
		confirmcode: null,
		email: null,
		confirmedEmail: null,
		select: null,
		generalError: [],
		checkbox: false,
		agreement: false,
		dialog: false,
		usertypeform: false,
		isLoading: false,
		password: null,
		confirmpassword: null,
		rules: {
			email: v => (v || '').match(/@/) || 'Please enter a valid email',
			length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
			password: v =>
				(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',

			confirmpassword: v =>
				(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
				'Confirm Password must contain an upper case letter, a numeric character, and a special character',

			required: v => !!v || 'This field is required',
		},
		emailRules: [v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'E-mail must be valid'],
		passwordRules: [
			v => !!v || 'Password is required',
			v => (v && v.length >= 5) || 'Password must have 5+ characters',
			v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
			v => /(?=.*\d)/.test(v) || 'Must have one number',
		],
	}),

	computed: {
		...mapGetters('option', ['industryList']),

		...mapGetters(['heardFromWhereOptions']),

		...mapState(['HFWTextLabels']),

		passwordConfirmationRule() {
			return this.password === this.confirmpassword || 'Password must match';
		},

		emailConfirmationRule() {
			return this.email === this.confirmedEmail || 'Email must match';
		},

		tenantId() {
			return this.$route.query.tid || process.env.VUE_APP_DEFAULT_TENANT_ID;
		},
	},

	mounted() {
		this.loadIndustries(this.tenantId);
	},

	methods: {
		...mapActions(['SignUp', 'AddToGroup']),

		...mapActions('option', ['LoadIndustries']),

		onChangeTelNumber(data) {
			this.phoneNumberFormatted = data.formattedNumber;
		},

		async loadIndustries() {
			await this.LoadIndustries(this.tenantId);
		},

		async signUp() {
			this.$refs.signupform.validate();
			if (!this.valid) return;

			this.loading = true;

			try {
				const { password, phoneNumberFormatted } = this;
				const industry = this.select;
				const username = this.email.toLowerCase().trim();
				const firstname = this.firstname;
				const lastname = this.lastname;
				const email = this.email.toLowerCase().trim();

				const tentantId = this.tenantId;

				const resp = await fetchTenant(tentantId);

				if (!resp.tenantId) {
					this.generalError = ['Incorrect Tenant Id'];
					return;
				}

				const result = await this.SignUp({
					username,
					password,
					attributes: {
						email,
						phone_number: phoneNumberFormatted,
						family_name: lastname,
						name: firstname,
						profile: industry,
						locale: 'company',
						'custom:heardFromWhere': this.heardFromWhere,
						'custom:heardFromWhereText': this.heardFromWhereText.text,
						'custom:tenant': resp.tenantId,
					},
				});

				await this.AddToGroup({ username: result.user.userSub, groupName: 'CompanyAdmin' });

				/* 
					window.sendinblue.identify(email, {
						SMS: phone_number_formatted,
						LASTNAME: lastname,
						FIRSTNAME: firstname,
						USER_ID: signup_response.userSub,
						ACCOUNT_TYPE: this.isPractice ? 'company' : 'professional',
						INDUSTRY: industry,
						EMAIL_VERIFIED: false,
					});
				 */

				this.$router.push({
					path: '/confirm-signup',
					query: {
						username,
						returnUrl: `/company/invite/accept/sign-in?challenge=signUp&step=completeInvite&token=${this.$route.query.token}`,
					},
				});
			} catch (err) {
				if (err.message == 'Invalid phone number format.') {
					this.errorMessage = 'Please use format +27 123456789';
				} else {
					this.errorMessage = 'Failed to sign-up and accept invite';
				}
				this.errorSnackbar = true;
			} finally {
				this.loading = false;
			}
		},

		async completeInviteProcess(user, token) {
			if (!user || !user.signInUserSession || !token) {
				this.errorMessage = 'Failed to accept invite';
				this.errorSnackbar = true;
				return false;
			}

			const groups = user.signInUserSession.getAccessToken().payload['cognito:groups'];
			if (!groups.includes('CompanyAdmin')) {
				this.errorMessage = 'You are already part of different group, contact support on what to do next';
				this.errorSnackbar = true;
				return false;
			}

			try {
				await this.AcceptCompanyInvite({ user, token });
				return true;
			} catch (_) {
				this.errorMessage = 'Failed to accept invite';
				this.errorSnackbar = true;
				return false;
			}
		},

		redirectToDashboard() {
			this.$router.push('/dashboard');
		},

		redirectToAuth() {
			this.$router.push('/');
		},
	},
};
</script>

<style></style>
